import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <AddCategoryTagClasses
  @category={{@category}}
  @tags={{if @tag (array @tag.id)}}
/>

{{#if @category}}
  <PluginOutlet
    @name="above-category-heading"
    @outletArgs={{hash category=@category tag=@tag}}
  />

  <section class="category-heading">
    {{#if @category.uploaded_logo.url}}
      <CategoryLogo @category={{@category}} />
      {{#if @category.description}}
        <p>{{dir-span @category.description htmlSafe="true"}}</p>
      {{/if}}
    {{/if}}

    <span>
      <PluginOutlet
        @name="category-heading"
        @connectorTagName="div"
        @outletArgs={{hash category=@category tag=@tag}}
      />
    </span>
  </section>
{{/if}}

{{body-class this.bodyClass}}

<section
  class={{concat-class
    "navigation-container"
    (if @category "category-navigation")
  }}
>
  <DNavigation
    @category={{@category}}
    @tag={{@tag}}
    @additionalTags={{@additionalTags}}
    @filterMode={{this.filterMode}}
    @noSubcategories={{@noSubcategories}}
    @canCreateTopic={{this.canCreateTopic}}
    @canCreateTopicOnTag={{@canCreateTopicOnTag}}
    @createTopic={{@createTopic}}
    @createTopicDisabled={{@createTopicDisabled}}
    @hasDraft={{this.currentUser.has_topic_draft}}
    @editCategory={{this.editCategory}}
    @showCategoryAdmin={{@showCategoryAdmin}}
    @createCategory={{this.createCategory}}
    @reorderCategories={{this.reorderCategories}}
    @canBulkSelect={{@canBulkSelect}}
    @bulkSelectHelper={{@bulkSelectHelper}}
    @skipCategoriesNavItem={{this.skipCategoriesNavItem}}
    @toggleInfo={{@toggleTagInfo}}
    @tagNotification={{@tagNotification}}
    @model={{@model}}
    @showDismissRead={{@showDismissRead}}
    @showResetNew={{@showResetNew}}
    @dismissRead={{@dismissRead}}
    @resetNew={{@resetNew}}
  />

  {{#if @category}}
    <PluginOutlet
      @name="category-navigation"
      @connectorTagName="div"
      @outletArgs={{hash category=@category tag=@tag}}
    />
  {{/if}}

  {{#if @tag}}
    <PluginOutlet
      @name="tag-navigation"
      @connectorTagName="div"
      @outletArgs={{hash category=@category tag=@tag}}
    />
  {{/if}}
</section>
*/
{
  "id": "twIlyDo/",
  "block": "[[[8,[39,0],null,[[\"@category\",\"@tags\"],[[30,1],[52,[30,2],[28,[37,2],[[30,2,[\"id\"]]],null]]]],null],[1,\"\\n\\n\"],[41,[30,1],[[[1,\"  \"],[8,[39,3],null,[[\"@name\",\"@outletArgs\"],[\"above-category-heading\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1],[30,2]]]]]],null],[1,\"\\n\\n  \"],[10,\"section\"],[14,0,\"category-heading\"],[12],[1,\"\\n\"],[41,[30,1,[\"uploaded_logo\",\"url\"]],[[[1,\"      \"],[8,[39,5],null,[[\"@category\"],[[30,1]]],null],[1,\"\\n\"],[41,[30,1,[\"description\"]],[[[1,\"        \"],[10,2],[12],[1,[28,[35,6],[[30,1,[\"description\"]]],[[\"htmlSafe\"],[\"true\"]]]],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n    \"],[10,1],[12],[1,\"\\n      \"],[8,[39,3],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"category-heading\",\"div\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1],[30,2]]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,[28,[35,7],[[30,0,[\"bodyClass\"]]],null]],[1,\"\\n\\n\"],[10,\"section\"],[15,0,[28,[37,8],[\"navigation-container\",[52,[30,1],\"category-navigation\"]],null]],[12],[1,\"\\n  \"],[8,[39,9],null,[[\"@category\",\"@tag\",\"@additionalTags\",\"@filterMode\",\"@noSubcategories\",\"@canCreateTopic\",\"@canCreateTopicOnTag\",\"@createTopic\",\"@createTopicDisabled\",\"@hasDraft\",\"@editCategory\",\"@showCategoryAdmin\",\"@createCategory\",\"@reorderCategories\",\"@canBulkSelect\",\"@bulkSelectHelper\",\"@skipCategoriesNavItem\",\"@toggleInfo\",\"@tagNotification\",\"@model\",\"@showDismissRead\",\"@showResetNew\",\"@dismissRead\",\"@resetNew\"],[[30,1],[30,2],[30,3],[30,0,[\"filterMode\"]],[30,4],[30,0,[\"canCreateTopic\"]],[30,5],[30,6],[30,7],[30,0,[\"currentUser\",\"has_topic_draft\"]],[30,0,[\"editCategory\"]],[30,8],[30,0,[\"createCategory\"]],[30,0,[\"reorderCategories\"]],[30,9],[30,10],[30,0,[\"skipCategoriesNavItem\"]],[30,11],[30,12],[30,13],[30,14],[30,15],[30,16],[30,17]]],null],[1,\"\\n\\n\"],[41,[30,1],[[[1,\"    \"],[8,[39,3],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"category-navigation\",\"div\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1],[30,2]]]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[8,[39,3],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"tag-navigation\",\"div\",[28,[37,4],null,[[\"category\",\"tag\"],[[30,1],[30,2]]]]]],null],[1,\"\\n\"]],[]],null],[13]],[\"@category\",\"@tag\",\"@additionalTags\",\"@noSubcategories\",\"@canCreateTopicOnTag\",\"@createTopic\",\"@createTopicDisabled\",\"@showCategoryAdmin\",\"@canBulkSelect\",\"@bulkSelectHelper\",\"@toggleTagInfo\",\"@tagNotification\",\"@model\",\"@showDismissRead\",\"@showResetNew\",\"@dismissRead\",\"@resetNew\"],false,[\"add-category-tag-classes\",\"if\",\"array\",\"plugin-outlet\",\"hash\",\"category-logo\",\"dir-span\",\"body-class\",\"concat-class\",\"d-navigation\"]]",
  "moduleName": "discourse/components/discovery/navigation.hbs",
  "isStrictMode": false
});